var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row full-height"},[_c('el-row',[_c('el-col',{staticStyle:{"overflow":"scroll"},attrs:{"span":24}},[_c('el-col',{staticClass:"right-panel",attrs:{"span":24}},[_c('MainContent')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }